import { showToast } from '@/components/ui/sonner';
import { handleError } from '@/lib/utils';
import { UPDATE_SESSION } from '@/pages/sessions/GraphQl/mutation';
import { SessionStatus } from '@/Types/gql/graphql';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

const useCancelSession = () => {
  const navigate = useNavigate();
  const [updateSession] = useMutation(UPDATE_SESSION, {
    refetchQueries: ['GetAllSession', 'GetSessionById', 'GetAllSessionsCount'],
  });

  const handleCancelSession = (id: string, programId: string, sportId: string) => {
    updateSession({
      variables: {
        data: {
          _id: id || '',
          programId: programId || '',
          ...(sportId && { sportId: sportId || '' }),
          sessionStatus: SessionStatus.Cancelled,
          roomId: '123',
        },
      },
      onCompleted: () => {
        showToast({ message: 'Session updated successfully', variant: 'success' });
        navigate('/', { replace: true });
      },
      onError: handleError,
    });
  };
  return { handleCancelSession };
};

export default useCancelSession;
